import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';

import Style from './SignOut.module.scss';

const Logout = ({
  language,
  loader,
  logoutInProcess,
  onClose,
  onLogout,
  renderLoader,
  renderLogo,
}) => {
  const {
    global_cancelButton: cancelButtonText,
    profileLogout_header: headerText,
    profileLogout_logoutButton: logoutButtonText,
    profileLogout_message: logoutMessage,
  } = language || {};
  const buttonContent = renderLoader ? loader : logoutButtonText;
  const onLogoClick = () => onClose({ goHome: true });
  return (
    <main className={Style.signOut}>
      <div className={Style.signOutContainer}>
        <div className={Style.headerSuccess}>{renderLogo(onLogoClick)}</div>
        <div className={Style.logoutContainer}>
          <h1 className={Style.logoutHeaderText}>{headerText}</h1>
          <div className={Style.logoutText}>{logoutMessage}</div>
        </div>
        <div className={Style.perksButtonContainer}>
          <button
            className={Style.btnPrimary}
            onClick={async () => {
              await onLogout();
              handleAnalytics({
                event: Events.PROFILE_LOGGED_OUT,
              });
            }}
            disabled={logoutInProcess}
          >
            {buttonContent}
          </button>
          <button className={Style.btnHollow} onClick={onClose}>
            {cancelButtonText}
          </button>
        </div>
      </div>
    </main>
  );
};

Logout.defaultProps = {
  language: {},
  onClose: noop,
  onLogout: noop,
  renderLogo: noop,
  logoutInProcess: null,
  loader: null,
  renderLoader: null,
};
Logout.propTypes = {
  language: PropTypes.shape({
    global_cancelButton: PropTypes.string,
    profileLogout_header: PropTypes.string,
    profileLogout_logoutButton: PropTypes.string,
    profileLogout_message: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onLogout: PropTypes.func,
  renderLogo: PropTypes.func,
  loader: PropTypes.node,
  logoutInProcess: PropTypes.bool,
  renderLoader: PropTypes.bool,
};

export default Logout;
